/** All available member types */
export enum MemberTypeEnum {
  /** Internal user */
  INTERNAL_USER = 'INTERNAL_USER',
  /** Group of internal users */
  INTERNAL_USER_GROUP = 'INTERNAL_USER_GROUP',
  /** External user */
  EXTERNAL_USER = 'EXTERNAL_USER',
}
